import Api from '@/services/Api'

export default {
  index (query) {
    return Api().get('betontvrtka', {
      params: query 
    })
  },
  show (betontvrtkaId) {
    return Api().get(`betontvrtka/${betontvrtkaId}`)
  },
  post (newbetontvrtka) {
    return Api().post('betontvrtka', newbetontvrtka)
  },
  put (betontvrtka) {
    return Api().put(`betontvrtka/${betontvrtka.id}`, betontvrtka)
  },
  delete (betontvrtkaId) {
    return Api().delete(`betontvrtka/delete/${betontvrtkaId}`)
  }
}